import api from './api';
import { toast } from 'react-toastify'

export function findAll() {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');
      
      const response = await api.get("vias", {
        headers: { authorization: `bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error('Erro ao buscar vias');
      return reject(e);
    }
  })
}

export function findById(id) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`vias/${id}`, {
        headers: { authorization: `bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error('Erro ao buscar via');
      return reject(e);
    }
  })
}

export function save(via) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.post('vias', via, {
        headers: { authorization: `bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      if(e.response.data.error && e.response.data.error.status === 'VIA_ALREADY_REGISTERED') {
        toast.error("Esta via já foi cadastrada");
      } else {
        toast.error("Falha ao cadastrar via");
      }

      return reject(e);
    }
  })
}

export function update(id, via) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.put(`vias/${id}`, via, {
        headers: { authorization: `bearer ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao salvar via");
      return reject(e);
    }
  })
}

export function remove(via) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.delete(`vias/${via.via_in_codigo}`, {
        headers: { authorization: `bearer ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao remover via");
      return reject(e);
    }
  })
}
